/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { Dropdown, Menu } from 'antd';
import Button from '../General/Button';
import { Link } from 'react-router-dom';
import { ButtonTypes } from '../General/Button';
import { DefaultInputTypes } from '../Inputs/Types';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

export interface DropDownProps extends DefaultInputTypes {
  label?: string | JSX.Element;
  Icon?: typeof React.Component | React.ComponentType;
  prefix?: JSX.Element | null;
  suffix?: JSX.Element | null;
  loading?: boolean;
  buttonType?: ButtonTypes;
  list: DropDownItem[];
}

export type DropDownLinkItem = {
  type: 'link';
  link: string;
  label: string;
  icon?: JSX.Element;
};

export type DropDownActionItem = {
  type: 'action';
  onClick: () => void | Promise<void>;
  label: string;
  icon?: JSX.Element;
};

export type DropDownItem = DropDownLinkItem | DropDownActionItem;

const DropDown: React.FC<DropDownProps> = ({
  label,
  Icon,
  shape = 'squre',
  color = 'textPrimary',
  bg = 'white border border-warmGray-200 shadow-sm hover:bg-gray-100 ',
  disabled,
  prefix,
  buttonType,
  suffix,
  list,
}) => {
  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu
          className="w-full"
          items={list.map((item, i) => ({
            key: item.label + i,
            onClick: item.type === 'action' ? item.onClick : undefined,
            label:
              item.type === 'action' ? (
                <div
                  className={` flex rounded-md items-center  space-s-2 w-full px-2 py-2 text-sm flex-row `}
                >
                  {item.icon && <div>{item.icon}</div>}
                  <div>
                    <ReturnTranslatedText
                      origintext={item.label}
                      text={`dropdowns.lists.${item.label}`}
                    />
                  </div>
                </div>
              ) : (
                <Link to={item.link}>
                  <div
                    className={` flex rounded-md items-center  space-s-2 w-full px-2 py-2 text-sm flex-row `}
                  >
                    {item.icon && <div>{item.icon}</div>}
                    <div>
                      <ReturnTranslatedText
                        origintext={item.label}
                        text={`dropdowns.titles.${item.label}`}
                      />
                    </div>
                  </div>
                </Link>
              ),
          }))}
        ></Menu>
      }
      arrow
    >
      <Button
        type={buttonType}
        onClick={() => {}}
        title={label}
        Icon={Icon}
        shape={shape}
        color={color}
        bg={bg}
        disabled={disabled}
        prefix={prefix}
        suffix={suffix}
      />
    </Dropdown>
  );
};

export default DropDown;
